'use client';

import { CreatePostView } from './create-post-view';
import { useNavigate, useParams } from 'react-router-dom';
import { EventsPageShell } from '@/pages/events/components/EventsPageShell';

export default function CreateSelectionPage() {
  const navigate = useNavigate();
  const { communityId } = useParams<{ communityId: string }>();

  const handleSelect = (type: string) => {
    if (type === 'lead') {
      navigate(`/${communityId}/create/lead`);
    } else if (type === 'thank_you') {
      navigate(`/${communityId}/create/thank-you`);
    } else if (type === 'testimonial') {
      navigate(`/${communityId}/create/testimonial`);
    } else if (type === 'general') {
      navigate(`/${communityId}/create/general`);
    } else if (type === 'meetup') {
      navigate(`/${communityId}/create/meetup`);
    } else if (type === 'event') {
      navigate(`/${communityId}/create/event`);
    } else if (type === 'poll') {
      navigate(`/${communityId}/create/poll`);
    }
  };

  return (
    <EventsPageShell>
      <CreatePostView onSelect={handleSelect} />
    </EventsPageShell>
  );
}
